import React from "react";
import { ReactComponent as Play } from "./assets/play.svg";

const playbutton = function () {
  <div className="play-button">
    <button type="button" className="play">
      <Play />
    </button>
  </div>;
};

export default Play;
